import { createApi } from '@reduxjs/toolkit/query/react';
import { ITimelineEventSummary } from '../../../../shared/types/timelineEventTypes';
import { networkBaseQuery } from './utils';

const CACHE_TIME_IN_MS = 60 * 1000 * 5; // 5 minutes

export const timelineEventsApi = createApi({
  reducerPath: 'timelineEventsApi',
  baseQuery: networkBaseQuery,
  keepUnusedDataFor: CACHE_TIME_IN_MS,
  endpoints: (builder) => ({
    getPublicTimelineEventList: builder.query<ITimelineEventSummary[], void>({
      query: () => ({ url: '/api/timeline-events' })
    })
  })
});

export const { useGetPublicTimelineEventListQuery } = timelineEventsApi;
